export default __webpack_public_path__ + "static/medgas_panel_w.a1907e0c6fd9b68ba18c264811310fbe.svg";